<template>
  <div
    v-if="displayInfo.buttonTxt"
    class="card-info-box"
    @click="clickCard"
  >
    <div class="card-info-sub-box">
      <img
        class="icon"
        src="https://qzonestyle.gtimg.cn/qzone/qzact/act/external/weishi/commercial/mini/cart.png"
      >
      <div class="card-info-text">
        {{ maxlength(displayInfo.buttonTxt, isShowMaterial) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelGoodsDisplayInfo } from '@/types/model';

const enum EEmitEvent {
  onClickCard = 'on-click-card',
}

export default defineComponent({
  props: {
    displayInfo: {
      type: Object as PropType<ModelGoodsDisplayInfo>,
      default: () => ({}),
    },
    isShowMaterial: {
      type: Boolean,
      default: false,
    },
  },
  emits: [EEmitEvent.onClickCard],
  data() {
    return {
    };
  },
  methods: {
    maxlength(data: string, type: boolean) {
      const len1 = 6;
      const len2 = 12;
      const maxLength = type ? len1 : len2;
      let dataString = String(data);
      if (dataString.length > maxLength) {
        dataString = `${dataString.slice(0, maxLength)}…`;
      }
      return dataString;
    },
    clickCard() {
      this.$emit(EEmitEvent.onClickCard);
    },
  },
});
</script>

<style lang="scss">
  .card-info-box {
    display: inline-block;
    @include responsiveStyleSingle(padding-left, 2.1333,'vw');
    @include responsiveStyleSingle(padding-right, 2.1333,'vw');
    @include responsiveStyleSingle(height, 6.4, 'vw');
    background: rgba(0,0,0,0.40);
    @include responsiveStyleSingle(border-radius,3.7333, 'vw');
    @include responsiveStyleSingle(font-size, 3.4667, 'vw');
    color: #FADF38;
    letter-spacing: 0;
    @include responsiveStyleSingle(line-height, 6.4, 'vw');
    position: relative;
    z-index: 10;
  }

  .card-info-sub-box {
    display: flex;
    @include responsiveStyleSingle(height, 6.4, 'vw');
    align-items: center;

    .icon {
      @include responsiveStyleSingle(width, 4.2667, 'vw');
      @include responsiveStyleSingle(height, 4.2667, 'vw');
      @include responsiveStyleSingle(margin-right, 1.0667, 'vw');
    }

    .card-info-text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
